import styled from 'styled-components';

export const Container = styled.div`
  .footer-new-letter {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
  }

  .footer-new-letter-info {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15rem;
    min-width: 15rem;
    gap: 0.6rem;
    font-weight: 500;
    color: var(--white);
  }

  form {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
    max-width: 51rem;
  }

  .input-simple {
    max-width: 20rem;
    border-radius: 0.4rem;
    background-color: var(--white_gray);

    input {
      flex: 1;
      width: 100%;
      padding: 0.8rem 1rem;
      background-color: transparent;
      border: none;
    }

    input::placeholder {
      font-size: 1.2rem;
      font-style: italic;
    }

    input.input-email {
      max-width: 25rem;
    }
  }

  button {
    max-width: 10rem;
    text-transform: none;
    color: var(--black);
    border-color: var(--green_light);
    background-color: var(--green_light);
  }

  @media (max-width: 1200px) {
    .footer-new-letter .footer-new-letter-info {
      width: 100%;
    }
  }

  @media (max-width: 1150px) {
    .footer-new-letter {
      flex-direction: column;
    }
  }

  @media (max-width: 768px) {
    form {
      flex-direction: column;

      .input-simple,
      .input-simple input {
        max-width: 100%;
      }

      button {
        align-self: center;
      }
    }
  }
`;
